import { StateMethods } from '@hookstate/core';
import { Alert, Button, Checkbox, Modal } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import React, { FC, ReactNode } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { CommandResult } from '../stores/types';

export type ModalProps = {
  className?: string;
  title: ReactNode;
  onNewItem: () => Promise<void>;
  onOkButtonIsDisabled?: boolean;
  onCancelButtonIsDisabled?: boolean;
  onClose: (response?: CommandResult<any>) => void;
  width?: string | number | undefined;
  body: React.ReactElement;
  errorMessage?: StateMethods<string | undefined, any>;
  okText: string;
  closable?: boolean;
  maskClosable?: boolean;
  addOtherVisible?: boolean;
  onAddOtherChecked?: (e: CheckboxChangeEvent) => void;
} & WithTranslation;

const NewModal: FC<ModalProps> = ({ t, ...props }) => {
  return (
    <Modal
      className={props.className}
      title={<h3 style={{ margin: '12px 16px' }}>{props.title}</h3>}
      open={true}
      onOk={() => props.onNewItem()}
      okButtonProps={{ disabled: props.onOkButtonIsDisabled, style: { width: '45%', float: 'right' } }}
      onCancel={() => {
        props.errorMessage?.set('');
        props.onClose();
      }}
      cancelButtonProps={{ type: 'default', disabled: props.onCancelButtonIsDisabled, style: { width: '45%' } }}
      okText={props.okText}
      width={props.width}
      cancelText={t('Cancel')}
      closable={props.closable}
      maskClosable={props.maskClosable}
      footer={(props.addOtherVisible && props.onAddOtherChecked
        ? [
            <Checkbox onChange={props.onAddOtherChecked} style={{ width: '30%', height: '100%' }}>
              {t('AddOther')}
            </Checkbox>,
          ]
        : []
      ).concat([
        <Button
          key="submit"
          type="primary"
          onClick={() => props.onNewItem()}
          disabled={props.onOkButtonIsDisabled}
          style={{ width: '30%', float: 'right' }}
        >
          {props.okText}
        </Button>,
        <Button key="back" type="default" onClick={() => props.onClose()} disabled={props.onCancelButtonIsDisabled} style={{ width: '30%' }}>
          {t('Cancel')}
        </Button>,
      ])}
    >
      {props.errorMessage?.get() && <Alert type="error" message={t(props.errorMessage.get() || '')} />}
      {props.body}
    </Modal>
  );
};
export default withTranslation()(NewModal);
